import { transition } from '@helpers/animate';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import scrollbars from '@helpers/scrollbars';
import { paragraphSmall } from '@helpers/typography';
import SectionWrapper from '@stories/Components/Global/SectionWrapper/SectionWrapper';
import styled from 'styled-components';
const Container = styled(SectionWrapper) ``;
const List = styled.ul `
  ${scrollbars};

  overflow: auto;
  white-space: nowrap;
`;
const Item = styled.li `
  ${paragraphSmall};

  line-height: ${fluid(52, 52)};
  display: inline-block;
  margin: 0 8px 0 0;

  &::after {
    content: '\\007C';
    margin-left: 8px;
  }

  &[data-ellip],
  &:last-child {
    &::after {
      display: none;
    }
  }
`;
const ItemLink = styled.a `
  ${transition('text-decoration-color')};
  ${paragraphSmall};

  text-decoration: underline;
  text-decoration-color: transparent;
  text-underline-offset: 2px;

  &:not([aria-current='location']).focus-ring,
  &:not([aria-current='location']):hover {
    text-decoration-color: currentColor;
  }

  &[aria-current='location'] {
    ${fonts.graphikCompact.semibold};
  }
`;
const BreadcrumbStyles = {
    Container,
    List,
    Item,
    ItemLink,
};
export default BreadcrumbStyles;
